module.exports = __webpack_public_path__ + "img/b2.a6f450f2.png";